<template>
    <div>
        <van-panel v-for="(task,index) in tasks">
            <template slot="header" >
                <div class="van-cell van-panel__header">
                    <div class="van-cell__title">
                        <span>{{task.title}}</span>
                        <div class="van-cell__label">处理人:{{task.assignName}}</div>
                        <div class="van-cell__label">客户:{{task.customerName}}</div>
                        <div class="van-cell__label">任务时间:【{{task.plannedStartTime|timeFormat}}~{{task.plannedEndTime|timeFormat}}】</div>
                        <div style="text-align: right;margin-top:5px; margin-right: -45px;">
                            <van-button hairline size="small" style="margin-right: 5px" @click="onShowList(task)">任务记录</van-button>
                            <van-button hairline size="small" type='primary' style="margin-right: 5px" v-if="(parseInt(auditStatus)==51 || task.assignId.indexOf(userId)>-1)&&status.includes(task.status)" @click="onEdit(task)">撰写</van-button>
                            <van-button hairline size="small" type="warning" @click="handleFinish(task)" v-if="(parseInt(auditStatus)==51 || task.assignId.indexOf(userId)>-1)&&status.includes(task.status)">完成任务</van-button>
                        </div>
                    </div>
                    <div class="van-panel__header-value">
                        <van-tag plain :type="onType(task.status)">{{task.statusCn}}</van-tag>
                    </div>
                </div>

            </template>
        </van-panel>
        <van-popup position="bottom" v-model="show" :overlay="true"   closeable
                   close-icon="close" close-icon-position="top-left">
            <div style="margin-top: 10px">
                <van-form @submit="handleRecordSave">
                    <div style="margin-top: 13px;margin-right: 12px;text-align: right">
                        <van-button type="info" round size="small" native-type="submit">保存</van-button>
                    </div>
                    <van-field
                            label="记录类型:"
                            label-width="100px"
                            input-align="left"
                            name="classify"
                            readonly
                            :rules="[{ required: true, message: '请选择' }]"
                    >
                        <template #input>
                            <van-radio-group v-model="formData.classify" direction="horizontal">
                                <van-radio name="RESET">申请重置</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field
                            label="重置理由:"
                            placeholder="请输入重置理由"
                            label-width="100px"
                            input-align="left"
                            name="remark"
                            v-model="formData.remark"
                            :rules="[{ required: true, message: '请输入重置理由' }]"
                    />
                </van-form>
            </div>
        </van-popup>

        <van-popup position="bottom" v-model="showList" :overlay="true"   closeable
                   close-icon="close" close-icon-position="top-right">
            <div style="margin-top: 10px">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        error-text="请求失败，点击重新加载"
                        @load="handleRecordList">
                    <van-cell>
                        <van-row style="text-align: center">
                            <van-col span="6">
                                时间
                            </van-col>
                            <van-col span="5">
                                类型
                            </van-col>
                            <van-col span="13">
                                备注
                            </van-col>
                        </van-row>
                    </van-cell>
                    <van-cell
                            style="padding: 20px"
                            v-for="item in list"
                            center>
                        <template>
                            <van-row style="text-align: center">
                                <van-col span="6">
                                    {{item.createTime|dateFormat}}
                                </van-col>
                                <van-col span="5">
                                    {{item.classifyCn}}
                                </van-col>
                                <van-col span="13">
                                    <van-notice-bar color="black" background="#FFFFFF" style="height:23px" >
                                        {{item.remark}}
                                    </van-notice-bar>
                                </van-col>
                            </van-row>
                        </template>
                    </van-cell>
                </van-list>
            </div>
        </van-popup>

    </div>
</template>

<script>
import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)
import { mapGetters } from 'vuex'
import {getAssignmentList,saveAssignment,saveAssignTask,getAssignTaskList} from '@/api/foreclosure'
import { debounce,cloneDeep } from 'lodash'
export default {
    name: 'assignment',
    props: {
        applyId: {
            type: String,
            default: ''
        }
    },
    computed: mapGetters([
        'userId','auditStatus'
    ]),
    data() {
        return {
            formData:{},
            tasks:[],
            show:false,
            bid:'',
            showList:false,
            list:[],
            loading: false,
            finished: false,
            status:['PENDING','OVERTIME']
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        loadData() {
            const self = this
            debounce(() => {
                getAssignmentList({applyId: this.applyId}).then(res=>{
                    self.tasks = res.data
                })
            }, 200)()

        },
        onType(status){
            const typeMap = {
                'PENDING': 'primary',
                'OVERTIME': 'danger',
                'COMPLETE':'success',
                'TOVOID':''
            }
            return  typeMap[status]
        },
        //完成任务
        handleFinish(record){
            this.$dialog.confirm({
                title: '完成任务',
                message: '您确定已完成【'+record.title+'】任务了？',
            }).then(() => {
                let params=cloneDeep(record)
                params.status='COMPLETE'
                saveAssignment(params).then(res=> {
                    if(res.success){
                        Toast.success(res.msg);
                        this.loadData()
                    }else{
                        Toast.fail(res.msg);
                    }
                })
            }).catch(() => {

            });

        },
        handleRecordSave(values){
            values.bid=this.bid
            saveAssignTask(values).then(res=> {
                if(res.success){
                    Toast.success("成功");
                    this.show=false
                }else{
                    Toast.fail(res.msg);
                }
            })
        },
        onEdit(task){
            this.show=true
            this.bid=task.id
        },
        onShowList(task){
            this.showList=true
            this.bid=task.id
            this.handleRecordList()
        },
        handleRecordList(){
            getAssignTaskList({ bid: this.bid }).then(res => {
                // 加载状态结束
                this.loading = false
                this.finished = true
                this.list = res.data
            })
        }
    }
}
</script>

<style scoped>

</style>
